import { useState } from 'react'
import { addImageToCanvas } from '../utils/canvasUtils'

export function useAIImageGeneration() {
  const [isGenerating, setIsGenerating] = useState(false)

  const generateImage = async ({ prompt, apiEndpoint, apiKey }) => {
    setIsGenerating(true)
    
    try {
      console.log('开始生成图片:', { prompt, apiEndpoint })
      
      // 调用AI API生成图片
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiKey}`
        },
        body: JSON.stringify({
          prompt: prompt,
          n: 1,
          size: '1024x1024',
          // 兼容不同API的参数
          model: 'dall-e-3', // OpenAI
          response_format: 'url'
        })
      })

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.error?.message || '生成失败')
      }

      const data = await response.json()
      
      // 处理不同API的响应格式
      let imageUrl
      if (data.data && data.data[0]?.url) {
        // OpenAI格式
        imageUrl = data.data[0].url
      } else if (data.artifacts && data.artifacts[0]?.base64) {
        // Stability AI格式
        imageUrl = `data:image/png;base64,${data.artifacts[0].base64}`
      } else if (data.url) {
        // 通用格式
        imageUrl = data.url
      } else {
        throw new Error('无法解析API响应')
      }

      console.log('图片生成成功:', imageUrl)

      // 将图片添加到画布
      if (window.tldrawEditor) {
        await addImageToCanvas(window.tldrawEditor, imageUrl, prompt)
        alert('✅ 图片已添加到画布！')
      } else {
        alert('⚠️ 画布未初始化，请刷新页面重试')
      }

    } catch (error) {
      console.error('生成图片失败:', error)
      alert(`❌ 生成失败: ${error.message}`)
    } finally {
      setIsGenerating(false)
    }
  }

  return {
    generateImage,
    isGenerating
  }
}
